<div [ngClass]="this.language == null || this.language === 'en' ? 'post-login-en-css' : 'post-login-other-css'">
  <div class="q-dashboard">
    <div style="display: inline;">
      <app-sidebar [sidebar]='sidebar'></app-sidebar>
      <app-sidebar-overlay [sidebar]='!sidebar'>
      </app-sidebar-overlay>
      <div class="main" id="main">
        <div>
          <app-topnavbar></app-topnavbar>
        </div>
        <div class="contentPadding">
          <router-outlet></router-outlet>
        </div>
        <div class="footer">
          <app-footer></app-footer>
        </div>
      </div>
    </div>
  </div>
</div>